export const MONTH_NAMES = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

export const compareDates = (filterLocalDateAtMidnight, cellValue) => {
	const cellDate = new Date(cellValue);

	if (cellValue == null || cellDate < filterLocalDateAtMidnight) {
		return -1;
	}

	if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
		return 0;
	}
	if (cellDate > filterLocalDateAtMidnight) {
		return 1;
	}
};

export const getPeriodString = (dateFrom, dateTo) => {
	const fromYear = getYearByDate(dateFrom);
	const toYear = getYearByDate(dateTo);
	const fromMonth = getMonthByDate(dateFrom);
	const toMonth = getMonthByDate(dateTo);

	if (fromYear === toYear) {
		const months =
			toMonth - fromMonth === 11
				? 'Full Year'
				: `${MONTH_NAMES[fromMonth]} - ${MONTH_NAMES[toMonth]}`;

		return `${fromYear} (${months})`;
	} else {
		return `${MONTH_NAMES[fromMonth]} ${fromYear} - ${
			MONTH_NAMES[toMonth]
		} ${toYear}`;
	}
};

export const getMonthByDate = date => {
	const d = new Date(date);

	return d.getMonth();
};

export const getYearByDate = date => {
	const d = new Date(date);

	return d.getFullYear();
};

export const getMonthYearRange = (dateFrom, dateTo) => {
	const fromDate = new Date(dateFrom);
	const toDate = new Date(dateTo);

	const options = { month: 'short' };

	const fromMonth = fromDate.toLocaleString('en-US', options);
	const toMonth = toDate.toLocaleString('en-US', options);

	const fromYear = String(fromDate.getFullYear()).slice(-2);
	const toYear = String(toDate.getFullYear()).slice(-2);

	return `${fromMonth} ${fromYear} - ${toMonth} ${toYear}`;
};
